import gql from 'graphql-tag';

export const mePermissions = gql`
  query {
    financingCurrentUser {
      id
      firstName
      lastName
      email
      permissions
      role {
        id
        name
      }
    }
  }
`;
